"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutboundLoadBalancerClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const commons_logs_1 = require("@deliverr/commons-logs");
const errors_1 = require("@deliverr/errors");
const OUTBOUND_LOAD_BALANCER_URL = process.env.OUTBOUND_LOAD_BALANCER_URL;
const OUTBOUND_LOAD_BALANCER_AUTH_USER = process.env.OUTBOUND_LOAD_BALANCER_AUTH_USER;
const OUTBOUND_LOAD_BALANCER_AUTH_PASSWORD = process.env.OUTBOUND_LOAD_BALANCER_AUTH_PASSWORD;
class OutboundLoadBalancerClient extends base_client_1.ApiBasicAuthClient {
    constructor(config = {
        baseURL: OUTBOUND_LOAD_BALANCER_URL,
        basicAuthUser: OUTBOUND_LOAD_BALANCER_AUTH_USER,
        basicAuthPassword: OUTBOUND_LOAD_BALANCER_AUTH_PASSWORD,
    }) {
        super(config);
        if (!config.baseURL) {
            commons_logs_1.log.warn("OUTBOUND_LOAD_BALANCER_URL environment variable is not set");
        }
        if (!config.basicAuthUser || !config.basicAuthPassword) {
            commons_logs_1.log.warn("OUTBOUND_LOAD_BALANCER_AUTH_USER and/or OUTBOUND_LOAD_BALANCER_AUTH_PASSWORD environment variable is not set");
        }
    }
    async registerCapacity(warehouseId, shipmentItems, releaseTime) {
        try {
            return await this.post(`/v2/warehouse/${warehouseId}/register`, this.formatCapacityRegistrationPayload(shipmentItems, releaseTime));
        }
        catch (err) {
            throw new errors_1.DeliverrError(err.response.data);
        }
    }
    async unregisterCapacity(warehouseId, shipmentItems, releaseTime) {
        try {
            return await this.post(`/v2/warehouse/${warehouseId}/unregister`, this.formatCapacityRegistrationPayload(shipmentItems, releaseTime));
        }
        catch (err) {
            throw new errors_1.DeliverrError(err.response.data);
        }
    }
    async updateProcessedUnitQty(warehouseId, shipmentItems) {
        try {
            return await this.post(`/v1/warehouse/${warehouseId}/processed-unit`, this.formatCapacityRegistrationPayload(shipmentItems));
        }
        catch (err) {
            throw new errors_1.DeliverrError(err.response.data);
        }
    }
    async getOCCsForActiveCapacityTrackingDays() {
        try {
            return await this.get("/v2/capacity-costs");
        }
        catch (err) {
            throw new errors_1.DeliverrError(err.response.data);
        }
    }
    async getOutboundCapacityCosts() {
        try {
            return await this.get("/v1/capacity-costs");
        }
        catch (err) {
            throw new errors_1.DeliverrError(err.response.data);
        }
    }
    async getActiveCapacities(warehouseId) {
        try {
            return await this.get(`/v1/capacity/warehouse/${warehouseId}`);
        }
        catch (err) {
            throw new errors_1.DeliverrError(err.response.data);
        }
    }
    async updateCapacity(warehouseId, unitLimit, shipDate) {
        try {
            return await this.put(`/v1/capacity/warehouse/${warehouseId}`, {
                warehouseId,
                unitLimit,
                shipDate,
            });
        }
        catch (err) {
            throw new errors_1.DeliverrError(err.response.data);
        }
    }
    formatCapacityRegistrationPayload(shipmentItems, releaseTime) {
        return {
            shipmentItems,
            releaseTime,
        };
    }
}
exports.OutboundLoadBalancerClient = OutboundLoadBalancerClient;
//# sourceMappingURL=OutboundLoadBalancerClient.js.map